import Route from '@ember/routing/route';
import { service } from '@ember/service';
import type IntlService from 'ember-intl/services/intl';
import translationsForEn from 'virtual:ember-intl/translations/en';

export default class ApplicationRoute extends Route {
  @service declare intl: IntlService;

  beforeModel() {
    this.intl.addTranslations('en', translationsForEn);
    this.intl.setLocale(['en']);
  }
}
